import { createBox } from '@shopify/restyle'

import { Theme } from '../utils/theme'

export const Box = createBox<Theme>()